/**
 * The real "Uptrack" wordmark: the U + green status-dot mark is the capital U,
 * then "ptrack". Generated by uptrack-mobile/tool/gen_icons.py (396x144). Two files, one per theme;
 * CSS shows the one that matches the OS theme. Decorative: the parent link names it.
 */
export function Wordmark({ height = 26 }: { height?: number }) {
  const width = Math.round((height * 396) / 144)
  return (
    <>
      <img src="/uptrack-wordmark-dark.png" alt="" aria-hidden="true" width={width} height={height} style={{ height }} className="hidden w-auto dark:block" />
      <img src="/uptrack-wordmark-light.png" alt="" aria-hidden="true" width={width} height={height} style={{ height }} className="w-auto dark:hidden" />
    </>
  )
}
